<template>
  <div class="search">
    <b-container>
      <div class="exam__list">
        <h3 class="exam__list__title">Tìm đề thi: {{ keyword }}</h3>

        <b-row>
          <b-col xs="12" md="4" v-for="exam in exams" :key="exam.id">
            <div class="exam__item">
              <div class="exam__item__header clearfix">
                <div class="exam__item__icon">
                  <img src="@/assets/images/ic_exam_thumb.png" width="64" />
                </div>
                <h4 class="exam__item__name">{{ exam.name }}</h4>
              </div>
              <div class="exam__item__content">
                <b-row class="justify-content-md-center">
                  <b-col xs="auto" md="auto">
                    <span class="exam__item__time"
                      ><fa-icon icon="clock" :style="{ color: '#17a2b8' }" />
                      {{ exam.time }} phút</span
                    >
                  </b-col>
                  <b-col col>
                    <span class="exam__item__rank"
                      >#{{ exam.description }}</span
                    >
                  </b-col>
                </b-row>
              </div>
              <div class="exam__item__footer clearfix">
                <b-link
                  :to="{
                    name: 'exam-detail',
                    params: { id: exam.id, slug: exam.slug }
                  }"
                  class="btn__normal float-right"
                  >Xem chi tiết</b-link
                >
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { checkResponse, get } from "@/utils/http";
import { APP_CONFIG } from "@/utils/constants";

export default {
  name: "Search",
  data() {
    return {
      keyword: this.$route.query.s,
      exams: {},
      error: false
    };
  },
  beforeMount() {
    this.getExams()
  },
  metaInfo() {
    return {
      title: "Tìm kiếm",
      meta: [{ vmid: "robots", name: "robots", content: "noindex, follow" }]
    };
  },
  methods: {
    async getExams() {
      return await get(`${APP_CONFIG.apiUrl}/exam/list?name=${this.keyword}`)
        .then(checkResponse)
        .then(response => {
          this.exams = response.data.data;
        })
        .catch(() => {
          this.error = true;
        });
    }
  }
};
</script>
